import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    data: null, // table数据

    addModalVisible: false, // 添加大科modal
    selectedData: null, // 判断modal为编辑还是新增
    tableLoading: false, // 表格加载
    editConfirmLoading: false, // 编辑加载
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
